<template>
  <Layout style="height: 100%" class="main">
   <!-- <Sider
      hide-trigger
      collapsible
      :collapsed-width="64"
      v-model="collapsed"
      class="left-sider"
      :style="{overflow: 'hidden'}"
    >
      <side-menu
        accordion
        ref="sideMenu"
        :collapsed="collapsed"
        :menu-list="menuList"
      >
        需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下
        <div class="logo-con">
          <img v-show="!collapsed" :src="maxLogo" key="max-logo" />
          <img v-show="collapsed" :src="minLogo" key="min-logo" />
        </div>
      </side-menu>
    </Sider> -->
    <Layout>
      <Header class="header-con" style="padding-right:0">
         <!-- :collapsed="collapsed" -->
        <!-- <header-bar @on-coll-change="handleCollapsedChange">
          <user :message-unread-count="unreadCount" :user-avator="userAvator" :img-avator="imgAvator" :user-bussice='userBussice'/>
          <fullscreen v-model="isFullscreen" style="margin-left: 10px;" />
        </header-bar> -->
      </Header>
      <Content class="main-content-con">
        <Layout class="main-layout-con">
          <!-- <div class="tag-nav-wrapper">
            <tags-nav
              :value="$route"
              @input="handleClick"
              :list="tagNavList"
              @on-close="handleCloseTag"
            />
          </div> -->
          <Content class="content-wrapper main-content">
            <keep-alive>
              <router-view :key="$route.fullpath"/>
            </keep-alive>
            <ABackTop :height="100" :bottom="80" :right="50" container=".content-wrapper"></ABackTop>
          </Content>
          <div class="botm">
            <Btm/>
          </div>
        </Layout>
        
      </Content>
    </Layout>


<Modal v-model="showclose" title="提示信息">
    <div style="text-align: center;width:80%;">当前账号已在另外一处登录，系统将自动退出。</div>
		<!-- 模态窗底部 -->
		<div slot="footer">
		  <Button type="primary" @click="closets">确认</Button>
		</div>
</Modal>

  </Layout>
</template>
<script>
import SideMenu from "./components/side-menu";
import Btm from "./components/btm";
import HeaderBar from "./components/header-bar";
import TagsNav from "./components/tags-nav";
import User from "./components/user";
import ABackTop from "./components/a-back-top";
import Fullscreen from "./components/fullscreen";
import { mapMutations } from "vuex";
import { getNewTagList, routeEqual } from "@/libs/util";
import routers from "@/router/route";
import menu from "@/router/menu";
import minLogo from "@/assets/images/logo-min.png";
import maxLogo from "@/assets/images/logo.png";
import "./main.less";
export default {
  name: "Main",
  components: {
    SideMenu,
    Btm,
    HeaderBar,
    TagsNav,
    Fullscreen,
    User,
    ABackTop
  },
  data() {
    return {
      collapsed: false,
      minLogo,
      maxLogo,
      isFullscreen: false,
      menuList: menu,
      //用于检测是否有重复登录定时器
      timer: null,
      showclose:false, //弹出重复登录提示框
    };
  },
  computed: {
    tagNavList() {
      return this.$store.state.app.tagNavList;
    },
    imgAvator() {
      return this.$store.state.user.userInfo.avatar;
    },
    userAvator() {
      return this.$store.state.user.userInfo.userName;
    },
    userBussice(){
      return this.$store.state.user.userInfo.adminName;
    },
    unreadCount() {
      return this.$store.state.user.unreadCount;
    }
  },
  methods: {
    ...mapMutations([
      "setBreadCrumb",
      "setTagNavList",
      "addTag",
      "setHomeRoute",
      "closeTag"
    ]),
    turnToPage(route) {
      let { name, params, query } = {};
      if (typeof route === "string") name = route;
      else {
        name = route.name;
        params = route.params;
        query = route.query;
      }
      if (name.indexOf("isTurnByHref_") > -1) {
        window.open(name.split("_")[1]);
        return;
      }
      this.$router.push({
        name,
        params,
        query
      });
    },
    handleCollapsedChange(state) {
      this.collapsed = state;
    },
    handleCloseTag(res, type, route) {
      console.log(res, type, route)
      if (type !== "others") {
        if (type === "all") {
          this.turnToPage(this.$config.homeName);
        } else {
          if (routeEqual(this.$route, route)) {
            console.log(this.$route, route)
            this.closeTag(route);
          }
        }
      }
      this.setTagNavList(res);
    },
    handleClick(item) {
      this.turnToPage(item);
    },
     //定时检测，是否有重复登录情况
    checkone(){
      this.$axios.post('/app/Auth/checkone').then((res) => {
        if (res.code == 1) {
          if (res.data==1){
            clearTimeout(this.timer);
            this.showclose=true
          }
        }
      })  
    },
    closets(){
      this.showclose=false
    },
    logout() {
      sessionStorage.removeItem("userInfo")
      localStorage.removeItem("tagNaveList");
      this.$router.replace({ name: "Login" });
    },
    //定时检测结束



  },
  watch: {
    $route(newRoute) {
      const { name, query, params, meta } = newRoute;
      this.addTag({
        route: { name, query, params, meta },
        type: "push"
      });
      this.setBreadCrumb(newRoute);
      this.setTagNavList(getNewTagList(this.tagNavList, newRoute));
    },
    showclose(newVal, oldVal) {
        if (newVal==false) this.logout()
    },
  },
  mounted() {
  
    /**
     * @description 初始化设置面包屑导航和标签导航
     */
    this.setTagNavList();
    this.setHomeRoute(routers);
    const { name, params, query, meta } = this.$route;
    this.addTag({
      route: { name, params, query, meta }
    });
    this.setBreadCrumb(this.$route);
    // 如果当前打开页面不在标签栏中，跳到homeName页
    if (!this.tagNavList.find(item => item.name === this.$route.name)) {
      this.$router.push({
        name: this.$config.homeName
      });
    }
     //定时检测是否重复登录
    const that=this
    this.timer=setInterval(that.checkone, 1000*15);
  }
};
</script>
<style scoped>
.botm{
  /* position: fixed; */
  /* bottom: 0; */
  width: 100%;
  background: #eee;
  height:3vh;
  line-height:2;
}
</style>
